import { FixedSizeFitContainer, ResponsiveSizeContainer, ResponsiveView } from "../../../../singlegame/ResponsiveHelpers";
import { AwardType, JackpotAwardOption, JackpotLevel, Money } from "../../../../singlegame/singlegame_api";
import { ScatterRandomAwardResult, SharedJackpotWin, SpinAndHoldCommonConfiguration } from "../../../api";
import { assertNotLess, assertNotNullish } from "../../../debug";
import { GetOrientation, Orientation } from "../../../FitScreen";
import { CreateSpineResources, Get, Log, Point, Rect, Scale, Size, TranslateScreen1To1 } from "../../../MyHelpers";
import { IWriteOnlyResourceManager } from "../../../ResourceManager/ResourceManager";
import { service } from "../../../services";
import { JackpotDisplayType, Settings } from "../../../Settings";
import { SpinTargetParams } from "../../SpinAnimation/SpinTargetParams";
import { S2_SpinnableReelsBigCanvas2 } from "../../SpinAnimation2/SpinnableReelsBigCanvas2";
import { ITransitionFactoryPIXIAPP } from "../../Transition/ITransitionFactoryPIXIAPP";
import { TransitionFactoryPIXIAPP } from "../../Transition/TransitionFactoryPIXIAPP";
import { COMET_PATH, ConstructReelsParams, TextureDialogLanguage } from "../SlotBonus";
import { AwardJPShowPIXIAPPResponsive } from "../SpinAndHold/AwardJPShowPIXIAPPResponsive";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldState } from "../SpinAndHold/SpinAndHoldState";
import { ExtededSpinAndHoldBonusGameState } from "./ExtendedSpinAndHold";
import { ExtendedSpinAndHoldPIXIApp } from "./ExtendedSpinAndHoldPIXIApp";
import * as PIXI from 'pixi.js'
import gsap from "gsap";
import { FountainPIXI } from "../../FountainAnimationPIXI";
import { JackpotShowtimeDuration } from "../../../JackpotProperties";
import { serviceProvider } from "../../../../singlegame/SinglegameServiceMap";




export class ExtendedSpinAndHoldPIXIAppResponsive extends ExtendedSpinAndHoldPIXIApp {

	protected override awardJPShowPIXIAPP: AwardJPShowPIXIAPPResponsive = null;
	protected fountainAnimation = serviceProvider.Resolve("FountainPIXI");


	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		this.awardJPShowPIXIAPP = new AwardJPShowPIXIAPPResponsive();
	}

	public override async PrepareTransition(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		let transitionResources = {
			audio: this.audio,
			logGroup: this.logGroup,
			systemContext: this.systemContext,
			gameName: this.gameName,
			resid: this.resid,
			fadeOut: true,
			skelentonDataSpine: globalThis?.jackpotDisplayGlobalResponsive?.GetSpineSkeleton() ?? null,
			transitionPIXITypeStyle: this.params.gameConfig.transitionPIXITypeStyle,
			bonusCommonPath: this.params.commonBonusResourcesBasePath,
			bonusName: this.bonusName,
		};

		let transitionViewFactory: ITransitionFactoryPIXIAPP = new TransitionFactoryPIXIAPP()
		this.transitionView = await transitionViewFactory.CreatePIXIAPPResponsive(transitionResources);
		await this.transitionView?.PrepareResources(resourceManager);

		this.transitionView.onTransitionEnd = () => {
			this.OnTransitionEnded()
		}

		this.transitionView.onTransitionStart = () => {
			this.OnTransitionStarted()
		}
	}

	public override Update(): void {
		super.Update();
		this.fountainAnimation?.Update();
	}

	protected override DestinationComet(): Point {
		if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row <= this.spinnableReels2.GetWindowSymbolSize().Height / 2 - 1) {
			// where the win is on the bottom
			return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(1080), Scale.W(1920), Scale.H(1080))).Center();
		}
		else {
			// where the win is on the top
			return TranslateScreen1To1(new Rect(Scale.X(0), Scale.Y(0), Scale.W(1920), Scale.H(1080))).Center();
		}
	}

	protected override async StartShowWin(jp: JackpotLevel, timerShow: number, award: Money) {
		this.audio.Stop(this.resid.ScopedResourceName("background"));
		let winJackpot: SharedJackpotWin = null

		this.awardJPShowPIXIAPP?.SetSkin(jp);
		this.awardJPShowPIXIAPP?.StarAnim();
		gsap.set(this.awardJPShowPIXIAPP?.ViewPIXIAPP(), { alpha: 0 });
		this.awardJPShowPIXIAPP.ViewPIXIAPP().visible = true;
		gsap.to(this.awardJPShowPIXIAPP?.ViewPIXIAPP(), { alpha: 1, duration: 0.5 });

		this.fountainAnimation.Create();
		await this.fountainAnimation.Start();

		//this.audio.Play(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Play(this.resid.ScopedResourceName(jp + "Voice"));

		gsap.to(this.awardJPShowPIXIAPP.ViewPIXIAPP(), {
			delay: (timerShow - 700) / 1000, alpha: 0, duration: 0.5, onComplete: () => {
				this.awardJPShowPIXIAPP.StopAnin();
				//this.audio.Stop(this.resid.ScopedResourceName("clasploop"));
				this.StopFontain(jp);
				winJackpot = null;
			}
		});
	}

	protected override async OnCometEnd(): Promise<void> {

		const Awards = this.scatterPositions[this.currentScatterCometIndex];
		const awardOption = Awards?.AwardOptionPosition.AwardOption;

		console.log(`OnCometEnd index ${this.currentScatterCometIndex}/${this.scatterPositions.length}`, Awards);
		//let JPAward = this.simpleEndSpinAction.find(b=>b.Phase == "End").WinSinceBonusStart.SequentialProgressiveNonProgressiveWins;
		//let awardJPOption = Awards.AwardOptionPosition.AwardOption;




		this.spineBonusTitleAward?.state?.setAnimation(0, "anim", false);
		this.spineWinAward?.state?.setAnimation(0, "anim", false);
		// start showtime for cash or jackpot
		if (awardOption.AwardType == AwardType.BetMultiplier ||
			awardOption.AwardType == AwardType.Credit
		) {
			this.SendWinInfo(Awards.Value.InCents, null);
			//this.timeoutNextCommetCash.Start();
			this.isShowed = true;
			this.NextComet();

		}
		else if (awardOption.AwardType == AwardType.Jackpot) {

			const jackpotAwardOption: JackpotAwardOption = awardOption as JackpotAwardOption;

			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared)
				if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
					this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2) this.bonusGameAwardViewPIXIAPP.visible = false;

			this.SendWinInfo(Awards.Value.InCents, jackpotAwardOption.JackpotLevel);
			//this.audio.Play(this.resid.ScopedResourceName("clasploop"));

			let jackpotShowDuration = 0;
			if (this.jackpotSharedShow != null) {
				jackpotShowDuration = this.jackpotSharedShow?.GetDuration(jackpotAwardOption.JackpotLevel)
			}
			else {
				jackpotShowDuration = JackpotShowtimeDuration[jackpotAwardOption.JackpotLevel];
			}

			assertNotLess(5000, jackpotShowDuration, "jackpotShowtimeDuration should have some minimum duration");

			await this.StartShowWin(jackpotAwardOption.JackpotLevel, 2000, Awards.Value);

			// if (Awards.AwardOptionPosition.AwardOption.AwardName == JackpotLevel.Jp4) {
			// 	// eslint-disable-next-line @typescript-eslint/no-floating-promises
			// 	void service.api.jpShowStart({
			// 		jackpotName: jackpotAwardOption.JackpotLevel,
			// 		duration: 5000,
			// 		win: Awards.Value.InCents,
			// 	});
			// }

			this.isShowed = false;

			setTimeout(() => {
				this.StopFontain(Awards.AwardOptionPosition.AwardOption.AwardName as JackpotLevel);

				if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Enable2plus1 == true && Settings.Screens == 3 ||
					this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2 && Settings.Screens == 2) {
					this.bonusGameAwardViewPIXIAPP.visible = true;
				}


				if (this.jackpotSharedHit != null) {
					this.jackpotSharedShow?.ShowShared(this.jackpotSharedHit);
					setTimeout(() => {
						this.jackpotSharedHit = null;
						this.NextComet();
					}, this.jackpotSharedShow?.GetDuration(this.jackpotSharedHit.JackpotLevel) + 500)
				}
				else {
					this.NextComet()
				}
			}, 2000)
		}
	}


	protected override StopFontain(jp: JackpotLevel): void {

		//this.audio.Stop(this.resid.ScopedResourceName(jp + "Background"));
		this.audio.Stop(this.resid.ScopedResourceName(jp + "Voice"));
		//this.audio.PlayLoop(this.resid.ScopedResourceName("background"));
		// SlotGameType1Shared.Instance().jackpotFountain.get(jp)?.RequestStop(this.resid);
		this.fountainAnimation.Destroy();
	}

	protected responsiveView: ResponsiveView = null;
	protected responsiveViewStats: ResponsiveView = null;
	protected override containerBonusViewApp: FixedSizeFitContainer = null;
	protected statsContainer: FixedSizeFitContainer = null;
	protected responsiveSizeContainer: ResponsiveSizeContainer = null;
	protected responsiveSizeStatsContainer: ResponsiveSizeContainer = null;
	protected lastOrientation: Orientation = null;

	protected override ConstructReelParams(constructReelsParams: ConstructReelsParams) {

		assertNotNullish(constructReelsParams.ReelSet, "ReelSet must be set when constructing reels");

		if (this.spinnableReels2) {
			this.spinnableReels2.Destroy();
		}

		this.spinnableReels2 = new S2_SpinnableReelsBigCanvas2(
			this.resid,
			{
				reelConfig: constructReelsParams.ReelSet,
				playWindow: constructReelsParams.PlayWindow
			},
			{
				windowRect: new Rect(0, 0, Scale.W(1920), Scale.H(1080 * 2)),
				leftBorderWidth: this.params.spinnableReelsParams.leftBorderWidth,
				rightBorderWidth: this.params.spinnableReelsParams.rightBorderWidth,
				topBorderWidth: this.params.spinnableReelsParams.topBorderWidth,
				bottomBorderWidth: this.params.spinnableReelsParams.bottomBorderWidth,
				backgroundImage: this.params.spinnableReelsParams.backgroundImage,

				pixiSpritesByName: this.params.pixiSpritesByName,

			},
			this.systemContext,
			constructReelsParams.Extended
		);

		this.spinnableReels2.OnCreatedCallback = () => {
			this.ReelBackgroundLoaded();
			//this.redrawPixiReels();
		};
	}

	private CreateResponsiveElements() {

		this.responsiveView = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: `responsive-view-${this.bonusName}` });
		this.responsiveViewStats = new ResponsiveView(window.innerWidth, window.innerHeight, { color: 0x220000, name: `responsive-view-stats-${this.bonusName}` });

		this.responsiveSizeStatsContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: `responsive-size-stats-container-${this.bonusName}` });
		this.responsiveSizeContainer = new ResponsiveSizeContainer(0, 0, 1, 1, NaN, { color: 0x990000, name: `responsive-size-container-${this.bonusName}` });

		this.containerBonusViewApp = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080 * 2), { color: 0xbb0000, name: 'reels-container' });
		this.responsiveSizeContainer.addChild(this.containerBonusViewApp);

		this.responsiveView.addChild(this.responsiveSizeContainer);

		this.statsContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080 * 2), { color: 0xbb0000, name: 'stats-container' });
		this.responsiveSizeStatsContainer.addChild(this.statsContainer);

		this.responsiveViewStats.addChild(this.responsiveSizeStatsContainer);

		this.gameViewApp.addChild(this.responsiveView, this.responsiveViewStats);
	}

	public override GameSelected(app: PIXI.Container) {
		app.removeChildren();
		this.gameViewApp = app;

		this.CreateResponsiveElements();

		this.awardJPShowPIXIAPP.CreatePIXIAPP();
		this.gameViewApp.addChildAt(this.awardJPShowPIXIAPP.ViewPIXIAPP(), 0)

		this.ConstructReels2(this.constructReelsParams);

		assertNotNullish(this.containerBonusViewApp, "Container bonus view app must be created");
		this.spinnableReels2.Create(this.containerBonusViewApp);



		this.scatterRandomAwardFeature.UpdateReels({
			playWindow: this.startAction.PlayWindow,
			reelSet: this.config.MultiReelSets[this.startAction.ReelSetId].map(reel => reel.Symbols)
		});

		this.scatterRandomAwardFeature.UpdateBet(this.bet);
		this.scatterRandomAwardFeature.Start();



		let targets: SpinTargetParams[] = this.constructReelsParams.ReelSet.map(r => {

			let stop: number = 0;
			if (this.startAction.ReelStops &&
				this.startAction.ReelStops[r.Index]) {
				stop = this.startAction.ReelStops[r.Index];
			}

			return <SpinTargetParams>{
				position: stop,
				anticipation: false,
				firstAnticipationReelIndex: -1,
			};
		});

		this.reelSetMapper2.SetTargets(targets, true);

		const scatterRandomAward = this.startAction.SpinWithFeatures.FeatureResults["ScatterRandomAward"] as ScatterRandomAwardResult;
		this.holdingFeature.UpdateReels(this.spinnableReels2);
		this.holdingFeature.CreatePIXIAPP();
		this.holdingFeature.Start(scatterRandomAward.ScattersPositionThisSpin, 1, this.params.symbolCollection.symbolCollectionMap.get("Symbol_SRA").showAward, false);


		this.CreateContainersPIXIAPPScreen1();
		this.CreateContainersPIXIAPPScreen2();

		if (this.jackpotSharedShow != null) {
			this.jackpotSharedShow.Create();
			this.containerBonusViewApp.addChild(this.jackpotSharedShow.View());
		}

		this.bonusMultiplier?.Create();
		if (this.bonusMultiplier != null) this.bonusGameInfoStats?.addChild(this.bonusMultiplier.View());


		this.created = true;


		this.OnResize();
	}

	private reelsView: PIXI.Container = null;

	protected override CreateContainersPIXIAPPScreen1() {

		this.reelsView = this.containerBonusViewApp.children.find(c => c.name == "containerSpinnableReels2ViewAppBonus") as PIXI.Container;
		this.reelsView.pivot.set(this.reelsView.width / 2, this.reelsView.height / 2);


		//fix stops spinnable reels 
		if (Settings.touchToStop == true) {
			this.gameViewApp.addEventListener('mousedown', () => {
				this.spinAnimation2.RequestStop();
			});
		}

		this.messageContainerPIXIAPP = new PIXI.Container()
		this.messageContainerPIXIAPP.width = Scale.W(1920);
		this.messageContainerPIXIAPP.height = Scale.H(1080);
		this.messageContainerPIXIAPP.x = 0
		this.messageContainerPIXIAPP.y = (this.containerBonusViewApp.fixedHeight / 4) * 2;
		this.messageContainerPIXIAPP.name = "messageContainerApp";
		this.messageContainerPIXIAPP.visible = false;

		this.introMessageContainerPIXIAPP = new PIXI.Container();
		this.introMessageContainerPIXIAPP.width = Scale.W(1152);
		this.introMessageContainerPIXIAPP.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.introMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.introMessageContainerPIXIAPP.width / 2)
		this.introMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.introMessageContainerPIXIAPP.height / 2)) - Scale.Y(75);
		this.introMessageContainerPIXIAPP.name = "introMessageContainer";
		this.messageContainerPIXIAPP.addChild(this.introMessageContainerPIXIAPP);

		let spriteintroSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
		spriteintroSpanishMessageContainerApp.width = Scale.W(1152),
			spriteintroSpanishMessageContainerApp.height = Scale.H(648);
		this.introMessageContainerPIXIAPP.addChild(spriteintroSpanishMessageContainerApp);


		this.spriteintroTextureMessageContainerApp = PIXI.Sprite.from((this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro);
		//this.spriteintroTextureMessageContainerApp.width = Scale.W(1052),
		//this.spriteintroTextureMessageContainerApp.height = Scale.H(548);
		this.spriteintroTextureMessageContainerApp.scale.set(Scale.H(1), Scale.W(1));
		this.spriteintroTextureMessageContainerApp.anchor.set(0.5, 0.5);
		this.spriteintroTextureMessageContainerApp.x = Scale.W(1152) / 2
		this.spriteintroTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.introMessageContainerPIXIAPP.addChild(this.spriteintroTextureMessageContainerApp);




		this.buttonIntroContainerApp = new PIXI.Container()
		this.buttonIntroContainerApp.name = "buttonIntroContainerApp"
		this.buttonIntroContainerApp.width = Scale.W(600);
		this.buttonIntroContainerApp.height = Scale.H(300);
		this.buttonIntroContainerApp.y = Scale.H(600);
		this.buttonIntroContainerApp.x = Scale.H(1152) / 2;
		this.buttonIntroContainerApp.pivot.set(Scale.W(600) / 2, Scale.H(300) / 2);
		this.buttonIntroContainerApp.interactive = true;
		this.introMessageContainerPIXIAPP.addChild(this.buttonIntroContainerApp);

		let spritebuttonIntroContainerApp = PIXI.Sprite.from(this.textureButtonBonus);
		spritebuttonIntroContainerApp.width = Scale.W(600),
			spritebuttonIntroContainerApp.height = Scale.H(300);
		this.buttonIntroContainerApp.addChild(spritebuttonIntroContainerApp);

		//create text style
		let textstyle = new PIXI.TextStyle({
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: Scale.fh(100),
			//fontStyle: 'italic',
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),
			wordWrap: true,
			wordWrapWidth: Scale.fh(300),
			lineJoin: 'round',
			textBaseline: "middle",
		});
		//this.app.renderer.view.style.position = 'fixed';
		let startTextView = new PIXI.Text(this.translator.t.freegameStart, textstyle);
		startTextView.anchor.set(0.5, 0.5);
		startTextView.x = (Scale.W(600) / 2);
		startTextView.y = (Scale.W(300) / 2);
		this.buttonIntroContainerApp.addChild(startTextView);

		//spritethis.buttonIntroContainerApp.tint = 0xff0000;		
		this.buttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == SpinAndHoldState.IntroMessage) {
				this.introMessageContainerPIXIAPP.visible = false;
				this.stateMachine.ChangeState(SpinAndHoldState.MultiplierShow);
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});



		//Create Final MessageContainer



		this.finalMessageContainerPIXIAPP = new PIXI.Container();
		this.finalMessageContainerPIXIAPP.width = Scale.W(1152);
		this.finalMessageContainerPIXIAPP.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.pivot.set(Scale.W(1152) / 2, Scale.H(648) / 2)
		this.finalMessageContainerPIXIAPP.x = (Scale.W(1920) / 2) - (this.finalMessageContainerPIXIAPP.width / 2)
		this.finalMessageContainerPIXIAPP.y = (Scale.W(1080 / 2) - (this.finalMessageContainerPIXIAPP.height / 2)) - Scale.Y(75);
		this.finalMessageContainerPIXIAPP.name = "finalMessageContainerApp";
		this.finalMessageContainerPIXIAPP.visible = false;
		this.finalMessageContainerPIXIAPP.interactiveChildren = true;
		this.finalMessageContainerPIXIAPP.interactive = true;
		this.messageContainerPIXIAPP.addChild(this.finalMessageContainerPIXIAPP);


		let spritefinalSpanishMessageContainerApp = PIXI.Sprite.from(this.textureDialogBonus);
		spritefinalSpanishMessageContainerApp.width = Scale.W(1152),
			spritefinalSpanishMessageContainerApp.height = Scale.H(648);
		this.finalMessageContainerPIXIAPP.addChild(spritefinalSpanishMessageContainerApp);


		this.spritefinalTextureMessageContainerApp = PIXI.Sprite.from((this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal);
		//this.spritefinalTextureMessageContainerApp.width = Scale.W(1052),
		//this.spritefinalTextureMessageContainerApp.height = Scale.H(548);
		this.spritefinalTextureMessageContainerApp.scale.set(Scale.H(1), Scale.W(1));
		this.spritefinalTextureMessageContainerApp.anchor.set(0.5, 0.5);
		this.spritefinalTextureMessageContainerApp.x = Scale.W(1152) / 2
		this.spritefinalTextureMessageContainerApp.y = (Scale.H(648) / 2) - Scale.W(50);
		this.finalMessageContainerPIXIAPP.addChild(this.spritefinalTextureMessageContainerApp);



		this.finalbuttonIntroContainerApp = new PIXI.Container()
		this.finalbuttonIntroContainerApp.name = "finalbuttonIntroContainerApp"
		this.finalbuttonIntroContainerApp.width = Scale.W(600);
		this.finalbuttonIntroContainerApp.height = Scale.H(300);
		this.finalbuttonIntroContainerApp.y = Scale.H(600);
		this.finalbuttonIntroContainerApp.x = Scale.H(1152) / 2;
		this.finalbuttonIntroContainerApp.pivot.set(Scale.W(600) / 2, Scale.H(300) / 2);
		this.finalbuttonIntroContainerApp.interactive = true;
		this.finalbuttonIntroContainerApp.interactiveChildren = true;

		this.finalMessageContainerPIXIAPP.addChild(this.finalbuttonIntroContainerApp);

		let spritebuttonFinalContainerApp = PIXI.Sprite.from(this.textureButtonBonus);
		spritebuttonFinalContainerApp.width = Scale.W(600),
			spritebuttonFinalContainerApp.height = Scale.H(300);
		//spritebuttonFinalContainerApp.tint = 0xff0000;
		this.finalbuttonIntroContainerApp.addChild(spritebuttonFinalContainerApp);

		let finalTextView = new PIXI.Text(this.translator.t.freegameExit, textstyle);
		finalTextView.x = (Scale.W(600) / 2);
		finalTextView.y = (Scale.W(300) / 2);
		finalTextView.anchor.set(0.5, 0.5),
			this.finalbuttonIntroContainerApp.addChild(finalTextView);

		this.finalbuttonIntroContainerApp.addListener("pointerdown", (ev: MouseEvent) => {
			if (this.stateMachine.State() == SpinAndHoldState.FinalMessage) {
				this.Spin();
			}
			else {
				Log.Error(this.logGroup, "Can't confirm intro message, current state: " + SpinAndHoldState[this.stateMachine.State()] + ", required state: " + SpinAndHoldState[SpinAndHoldState.IntroMessage]);
			}
		});


		this.skipCometMessageContainer = new PIXI.Container();
		this.skipCometMessageContainer.name = "skipCometMessageContainer";
		this.skipCometMessageContainer.height = Settings.ScreenHeight;
		this.skipCometMessageContainer.width = Settings.ScreenWidth;
		this.skipCometMessageContainer.x = Settings.ScreenWidth / 2;
		this.skipCometMessageContainer.y = (Settings.ScreenHeight * Settings.Screens - 1) - Scale.Y(300);
		//this.skipCometMessageContainer.alpha = 0;
		this.skipCometMessageContainer.visible = false;



		this.containerBonusViewApp.addChild(this.skipCometMessageContainer);

		let graphics = new PIXI.Graphics();
		graphics.beginFill(0xffffff);
		graphics.tint = 0x000000;
		graphics.alpha = 0.8;
		graphics.drawRoundedRect(0, 0, Scale.W(576), Scale.H(216), 50);
		graphics.endFill();
		graphics.pivot.set(Scale.W(576) / 2, Scale.H(216) / 2);
		this.skipCometMessageContainer.addChild(graphics);

		let skipMessageCommets = new PIXI.Text(this.translator.t.skipMessageCommets, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: Scale.fh(50),
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),
			wordWrapWidth: Scale.H(487),
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			//textBaseline : "middle",			
		});
		skipMessageCommets.pivot.set(skipMessageCommets.width / 2, skipMessageCommets.height / 2);
		this.skipCometMessageContainer.addChild(skipMessageCommets);
		//skipMessageBackgroundCommets.appendChild(this.translator.Anchor(() => this.translator.t.skipMessageCommets));

		this.translator.SetOnLanguageChangedCallback(() => {
			this.spriteintroTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusIntro;
			this.spritefinalTextureMessageContainerApp.texture = (this.textureByLanguage[this.translator.t.languageEnglish.toLocaleLowerCase()] as TextureDialogLanguage).textureBonusFinal;
			startTextView.text = this.translator.t.freegameStart;
			finalTextView.text = this.translator.t.freegameExit;
			skipMessageCommets.text = this.translator.t.skipMessageCommets;
		});
		this.skipMessageHide = this.systemContext.TimingContext().CreateTimeout("skipMessageHideShowTime", 1500, () => {
			this.skipCometMessageContainer.visible = false;
		});
		this.unclokFeatureViewPIXAPP = this.unlockFeature.CreatePIXIAPP(this.spinnableReels2.GetWindowRect(), this.spinnableReels2.GetSymbolSize());

		this.reelsView.addChild(this.holdingFeature.ViewPIXIAPP());
		this.reelsView.addChild(this.unclokFeatureViewPIXAPP);
		// this.reelsView.addChild(this.commetView.ViewPIXIAPP());
		this.reelsView.addChild(this.messageContainerPIXIAPP);
	}

	public override Start(): void {
		super.Start()
	}

	protected override InternalNextComet() {
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length) {
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.startAction.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.startAction.WinSinceGameStart.TotalWin.InCents))
			this.timeoutFinalMessageState.Start();
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isMovedWincontainer == true) {
					//this.animBottomToTopWinContainer.restart();
					let yPosition = 0;
					// if (Settings.Enable2plus1 == true) yPosition = Scale.Y(1085);
					gsap.to(this.bonusGameAwardViewPIXIAPP
						, {
							duration: 1,
							y: yPosition,
						});

					//its moved need turn of flag for dont move all time
					this.isMovedWincontainer = false;
					//add some delay for wait move container and later show comet anim
					this.timeoutCometShowtime.Start();
					//setTimeout(() => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]); }, 1000)
				} else {
					//jumps to cometshowTime dosent need add delay here
					this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
				}
			}
		}
	}

	protected override SendWinInfo(win: number, jp?: JackpotLevel) {
		//this.screenProtocol?.Send(new SpinAndHoldMessages.WinValue(win), this.screenProtocolScope);	
		//missing send money formated
		this.winAwardBonus += win;
		this.containerValueWinAwardText.text = service.moneyFormatter.FormatCurrency(this.winAwardBonus);
		// if(jp != null) this.jackpotSharedShow?.SetAward(jp,win);

		if (jp != null) {

			// find jackpot award index from all award indexes
			let jackpotAwardIndex = -1;
			for (let i = 0; i <= this.currentScatterCometIndex; i++) {
				if (this.scatterPositions[i].AwardOptionPosition.AwardOption.AwardType == AwardType.Jackpot) {
					jackpotAwardIndex++;
				}
			}

		}
	}

	protected override CreateContainersPIXIAPPScreen2() {

		this.bonusGameInfoStats = new PIXI.Container();
		this.bonusGameInfoStats.name = "bonusGameInfoStats";


		this.statsContainer.addChild(this.bonusGameInfoStats);

		this.CreateTitleStckySpin();
		this.CreateScatterWinCount();
		//create text style
		// let textstyle = new PIXI.TextStyle({
		//     fontFamily: 'NotoSansDisplay-Bold',			
		// 	fontSize: Scale.fh(250),			
		// 	fontWeight: 'bold',
		// 	fill: ["#F2E416", "#F2BE22" , "#C2760E" , "#F2BE22", "#F2E416" ], // gradient
		// 	stroke: 'black',
		// 	strokeThickness: Scale.fh(10),			
		// 	//wordWrap: true,			
		// 	lineJoin: 'round',
		// 	//textBaseline : "middle",			
		// });

		//create Win Text SRA
		let winCountTextPIXIAPP = new PIXI.Text(this.session.ScattersDisplayed, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 70,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		winCountTextPIXIAPP.anchor.set(0.5, 0.5);
		winCountTextPIXIAPP.scale.set(1, -1);
		winCountTextPIXIAPP.position.set(100, 0);
		//scatterWinCountContainer.addChild(winCountTextPIXIAPP);
		this.winCountTextPIXIAPP = winCountTextPIXIAPP;

		//Create Win Text SRA info
		let winTextPIXIAPP = new PIXI.Text(this.translator.t.totalwinHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 35,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
		});
		winTextPIXIAPP.anchor.set(0.5, 0.5);
		winTextPIXIAPP.scale.set(1, -1);
		winTextPIXIAPP.position.set(-50, 0);
		//winTextPIXIAPP.position.set(Scale.W(300),Scale.H(440));	   	   		
		//scatterWinCountContainer.addChild(winTextPIXIAPP);

		//this.winCountTextPIXIAPP = winTextPIXIAPP;

		//add container to spine
		let containerchildrensSpineWinCount = this.spineWinCountContainer?.children as PIXI.Container[];
		containerchildrensSpineWinCount?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(winCountTextPIXIAPP);
				container.addChild(winTextPIXIAPP);
			}
		});


		this.CreateSpinsRemaining();
		this.translator.SetOnLanguageChangedCallback(() => {

			winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			//spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});

		this.CreateAwarViewPIXIAPP();
	}

	public override ChangeStateCanvas(state: ExtededSpinAndHoldBonusGameState, runRemaining: number = 0) {
		this.spinRemainingTextPIXIAPP.text = this.session.RunsRemaining

	}

	protected override CreateAwarViewPIXIAPP() {
		this.bonusGameAwardViewPIXIAPP = new PIXI.Container();
		this.bonusGameAwardViewPIXIAPP.name = "bonusGameAwardViewPIXIAPP";
		this.bonusGameAwardViewPIXIAPP.alpha = 0;
		this.reelsView.addChild(this.bonusGameAwardViewPIXIAPP);


		//create container and spine bonus title 
		let bonusWinAwardTitle = new PIXI.Container();
		bonusWinAwardTitle.name = "bonusWinAwardTitle";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardTitle);
		this.spineBonusTitleAward = CreateSpineResources(this.jsonBonusWinTitleSpine);
		//this.spineBonusTitleAward.scale.set(Scale.XY(1));		
		this.spineBonusTitleAward.state.timeScale = 1.5;
		bonusWinAwardTitle.x = Scale.X(78);
		bonusWinAwardTitle.y = Scale.Y(199);
		bonusWinAwardTitle.addChild(this.spineBonusTitleAward);



		//create container and spine bonus title 
		let bonusWinAwardContainer = new PIXI.Container();
		bonusWinAwardContainer.name = "bonusWinAwardContainer";
		this.bonusGameAwardViewPIXIAPP.addChild(bonusWinAwardContainer);
		this.spineWinAward = CreateSpineResources(this.jsonWinAwardBonusSpine);
		this.spineWinAward.state.timeScale = 1.5
		//bonusWinAwardContainer.x = Settings.ScreenWidth / 2;
		bonusWinAwardContainer.y = Settings.ScreenHeight / 2;
		bonusWinAwardContainer.addChild(this.spineWinAward);

		console.log("Spine:", this.spineWinAward);



		//create container 
		let containerValue = new PIXI.Container();
		containerValue.name = "containerValue";
		//containerValue.pivot.set(this.positionSpinnableReelsSpinePivotContainer.width, this.positionSpinnableReelsSpinePivotContainer.height);
		containerValue.scale.set(1, -1);
		containerValue.position.y = (Settings.ScreenHeight * (Settings.Screens - 1)) * -1;


		//add container to spine
		let containerchildrensSpine = this.spineWinAward?.children as PIXI.Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				//create Win Text SRA
				this.containerValueWinAwardText = new PIXI.Text("?", {
					fontFamily: 'NotoSansDisplay-Bold',
					fontSize: 230,
					fontWeight: 'bold',
					fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
					stroke: 'black',
					strokeThickness: 10,
					//wordWrap: true,			
					lineJoin: 'round',
					//textBaseline : "middle",			
				});
				this.containerValueWinAwardText.scale.set(1, -1);
				this.containerValueWinAwardText.anchor.set(0.5, 0.5);
				container.addChild(this.containerValueWinAwardText)
			}
		});

		containerchildrensSpine = null;


		//create Win Text SRA
		let containerValueWinAward = new PIXI.Text("?", {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: Scale.fh(120),
			fontWeight: 'bold',
			fill: ["#F2E416", "#F2BE22", "#C2760E", "#F2BE22", "#F2E416"], // gradient
			stroke: 'black',
			strokeThickness: Scale.fh(10),
			//wordWrap: true,			
			lineJoin: 'round',
			//textBaseline : "middle",			
		});
		containerValueWinAward.anchor.set(0.5, 0.5);
		containerValue.addChild(containerValueWinAward)


		if (Settings.Screens == 2 || Settings.Enable2plus1) {
			this.bonusGameAwardViewPIXIAPP.position.set(Scale.X(3732), Scale.Y(161.5));
			if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidSinShared2S || Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotPyramidJP4SharedJP3SinShared2S)
				this.bonusGameAwardViewPIXIAPP.position.set(Scale.X(3732), Scale.Y(-300));
		}
	}

	protected override CreateScatterWinCount() {
		//create container and spine WinCount 
		let scatterWinCountContainer = new PIXI.Container();
		scatterWinCountContainer.name = "scatterWinCountContainer";
		this.bonusGameInfoStats.addChild(scatterWinCountContainer);
		this.spineWinCountContainer = CreateSpineResources(this.jsonSpinsRemainingSpine);
		scatterWinCountContainer.addChild(this.spineWinCountContainer);
		this.spineWinCountContainer.pivot.set(435 / 2, 159 / 2);
		// scatterWinCountContainer.pivot.set(this.spineWinCountContainer.width / 2, this.spineWinCountContainer.height / 2);
		this.spineWinCountContainer?.state.setAnimation(0, "anim", true);
	}

	protected override CreateSpinsRemaining() {
		//create container and spine Spins Remaining
		let spinsRemainingContainer = new PIXI.Container();

		spinsRemainingContainer.name = "spinsRemainingContainer";
		this.bonusGameInfoStats.addChild(spinsRemainingContainer);
		this.spineSpinsRemaining = CreateSpineResources(this.jsonSpinsRemainingSpine);
		spinsRemainingContainer.addChild(this.spineSpinsRemaining);
		this.spineSpinsRemaining.state.apply(this.spineSpinsRemaining.skeleton);
		this.spineSpinsRemaining.state.update(0);
		this.spineSpinsRemaining.pivot.set(435 / 2, 159 / 2);
		this.spineSpinsRemaining?.state?.setAnimation(0, "anim", true);

		//create text spins remaning info
		let spinRemainingTextInfoPIXIAPP = new PIXI.Text(this.translator.t.totalleftHoldAndSpin, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 35,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			wordWrap: true,
			lineJoin: 'round',
			align: "center",
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		spinRemainingTextInfoPIXIAPP.anchor.set(0.5, 0.5);
		spinRemainingTextInfoPIXIAPP.scale.set(1, -1);
		spinRemainingTextInfoPIXIAPP.position.set(-50, 0);


		//create spins remaning 
		this.spinRemainingTextPIXIAPP = new PIXI.Text(this.session.RunsRemaining, {
			fontFamily: 'NotoSansDisplay-Bold',
			fontSize: 70,
			fontWeight: 'bold',
			fill: ["#F20505", "#F20505", "#F20505", "#F20505", "#F20505"], // gradient
			stroke: 'white',
			strokeThickness: 10,
			//wordWrap: true,			
			lineJoin: 'round',
			dropShadow: true,
			dropShadowColor: "#000000",
			dropShadowDistance: 5,
			dropShadowAngle: 0.52,
			dropShadowAlpha: 1,
			//textBaseline : "middle",			
		});
		this.spinRemainingTextPIXIAPP.anchor.set(0.5, 0.5);
		this.spinRemainingTextPIXIAPP.scale.set(1, -1);
		this.spinRemainingTextPIXIAPP.position.set(100, 0);
		// this.spinRemainingTextPIXIAPP = spinRemainingTextPIXIAPP;

		//add container to spine
		let containerchildrensSpine = this.spineSpinsRemaining?.children as PIXI.Container[];
		containerchildrensSpine?.forEach((container) => {
			if (container.name == "containerValue") {
				container.addChild(spinRemainingTextInfoPIXIAPP);
				container.addChild(this.spinRemainingTextPIXIAPP);
			}
		});

		this.translator.SetOnLanguageChangedCallback(() => {

			//winTextPIXIAPP.text = this.translator.t.totalwinHoldAndSpin;
			spinRemainingTextInfoPIXIAPP.text = this.translator.t.totalleftHoldAndSpin;
		});

	}

	protected override SetPositionAwardContainer(): void {
		if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) {
			//top position
			this.bonusGameAwardViewPIXIAPP.position.y = COMET_PATH.height * -1;//Scale.Y(-58);
			// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1085);
			this.isMovedWincontainer = false;
		} else {
			//bottom postion
			this.bonusGameAwardViewPIXIAPP.position.y = COMET_PATH.height;
			// if(Settings.Enable2plus1 == true )this.bonunsGameAwardViewPIXIAPP.position.y = Scale.Y(1988);
			this.isMovedWincontainer = true;
		}
	}

	protected override WinCountShow() {
		// super.WinCountShow();
		this.bonusMultiplier?.Hide()
		//change position for winContainer 
		if (this.bonusGameAwardViewPIXIAPP != null) {
			// let xPosition = 0;
			gsap.to(this.bonusGameAwardViewPIXIAPP, { alpha: 1, duration: 1 });//(this.bonunsGameAwardViewPIXIAPP, { x: xPosition, duration: 1, ease: Elastic.easeOut.config(0.50, 0.4) });
		}

		this.SetPositionAwardContainer()


		// if (globalThis.jackpotDisplayGlobal != null) {
		// 	TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 0.8, {
		// 		alpha: 0
		// 	});
		// }
	}


	protected override CreateTitleStckySpin() {
		//create container and spine bonus title 
		let bonusTitleContainer = new PIXI.Container();
		bonusTitleContainer.name = "bonusTitleContainer";
		this.bonusGameInfoStats.addChild(bonusTitleContainer);
		this.spineBonusTitle = CreateSpineResources(this.jsonBonusTitleSpine);
		this.spineBonusTitle.pivot.set(1161 / 2, 141.3 / 2);
		this.spineBonusTitle.position.set(0, 0)
		bonusTitleContainer.addChild(this.spineBonusTitle);
		// bonusTitleContainer.pivot.set(this.spineBonusTitle.width / 2, this.spineBonusTitle.height / 2);
		//this.spineBonusTitle = spineBonusTitle;
	}
	public override OnResize(): void {

		if (!this.created) return;

		this.responsiveView?.setAvailableSize(window.innerWidth, window.innerHeight);
		this.responsiveViewStats?.setAvailableSize(window.innerWidth, window.innerHeight);
		this.transitionView?.OnResize()
		this.awardJPShowPIXIAPP?.OnResize()
		this.scaleGame();
		this.resizeCallback?.();
	}

	private scaleGame() {

		this.SetToDefault();

		const counters = new Size(435, 159);
		const bonusMultiplierView = this.bonusMultiplier?.View() ?? null;
		const titleSize = new Size(1161, 141.3)
		const bonusMultiplierSize = new Size(808, 800)
		this.bonusMultiplier.View().pivot.set(808 / 2, 800 / 2)


		if (GetOrientation() == Orientation.Landscape) {

			const availableWidth = this.containerBonusViewApp.fixedWidth;
			const availableHeight = this.containerBonusViewApp.fixedHeight / 4;

			const scaleX = counters.Width / availableWidth;
			const scaleY = counters.Height / availableHeight;
			const scale = Math.min(scaleX, scaleY);

			const titleScaleX = titleSize.Width / availableWidth;
			const titleScaleY = titleSize.Height / availableHeight;
			const scaleTitle = Math.min(titleScaleX, titleScaleY);

			this.responsiveSizeStatsContainer.percentWidth = 0.33 * 0.9;
			this.responsiveSizeStatsContainer.percentHeight = 0.85;
			this.responsiveSizeStatsContainer.percentX = 0;
			this.responsiveSizeStatsContainer.percentY = 0;

			this.responsiveSizeContainer.percentWidth = 0.33;
			this.responsiveSizeContainer.percentHeight = 0.85;
			this.responsiveSizeContainer.percentX = 0.33;
			this.responsiveSizeContainer.percentY = 0;

			this.containerBonusViewApp.fixedHeight = Scale.H(1080 * 2)
			this.statsContainer.fixedHeight = Scale.H(1080 * 2);

			//const positionX = (this.statsContainer.fixedWidth - (counters.Width * scale)) / 2

			//column1
			{
				const gap = availableHeight / 4;

				this.spineBonusTitle.scale.set(scaleTitle);
				this.spineBonusTitle.position.x = this.statsContainer.fixedWidth / 2;
				this.spineBonusTitle.position.y = gap + availableHeight / 2;

				this.spineWinCountContainer.scale.set(scale * 2);
				this.spineWinCountContainer.position.x = this.statsContainer.fixedWidth / 2;//(availableWidth - this.spineWinCountContainer.width) / 2;
				this.spineWinCountContainer.position.y = (gap + availableHeight / 2) * 2;//availableHeight / 2;

				this.spineSpinsRemaining.scale.set(scale * 2);
				this.spineSpinsRemaining.position.x = this.statsContainer.fixedWidth / 2;// availableWidth / 4;
				this.spineSpinsRemaining.position.y = (gap + availableHeight / 2) * 3;//availableHeight / 2;

				if (bonusMultiplierView) {
					const scaleMultiplierX = availableWidth / bonusMultiplierSize.Width;
					const scaleMultiplierY = availableHeight / bonusMultiplierSize.Height;
					const scaleMultiplier = Math.min(scaleMultiplierX, scaleMultiplierY);
					bonusMultiplierView.scale.set(scaleMultiplier * 4);
					bonusMultiplierView.position.x = (this.statsContainer.fixedWidth) / 2;
					bonusMultiplierView.position.y = (gap + availableHeight / 2) * 5;
				}

				// this.bonusGameInfoStats.x = (this.statsContainer.fixedWidth - this.bonusGameInfoStats.width) / 2;
				this.bonusGameInfoStats.y = (this.statsContainer.fixedHeight - this.bonusGameInfoStats.height) / 4;

			}

			//column2
			{
				this.reelsView.position.x = (this.containerBonusViewApp.fixedWidth ) / 2
				this.reelsView.position.y = (this.containerBonusViewApp.fixedHeight) / 2

			}

			return;
		}

		this.responsiveSizeStatsContainer.percentWidth = 1;
		this.responsiveSizeStatsContainer.percentHeight = 0.25;
		this.responsiveSizeStatsContainer.percentX = 0;
		this.responsiveSizeStatsContainer.percentY = 0;

		this.responsiveSizeContainer.percentWidth = 1;
		this.responsiveSizeContainer.percentHeight = 0.25;
		this.responsiveSizeContainer.percentX = 0;
		this.responsiveSizeContainer.percentY = 0.25;

		this.containerBonusViewApp.fixedHeight = Scale.H(1080);
		this.statsContainer.fixedHeight = Scale.H(1080);

		//Stats
		{
			const availableWidth = this.statsContainer.fixedWidth;
			const availableHeight = this.statsContainer.fixedHeight / 3;
			//row1
			{

				const scaleX = availableWidth / titleSize.Width;//titleSize.Width / availableWidth;
				const scaleY = availableHeight / titleSize.Height;//titleSize.Height / availableHeight
				const scale = Math.min(scaleX, scaleY);

				this.spineBonusTitle.scale.set(scale * 0.9);
				this.spineBonusTitle.position.x = availableWidth / 2;
				this.spineBonusTitle.position.y = availableHeight / 2;

			}
			//row2
			{
				const availableWidthRow2 = availableWidth / 2;
				const scaleX = counters.Width / availableWidthRow2;
				const scaleY = counters.Height / availableHeight;
				const scaleRow2 = Math.min(scaleX, scaleY);

				this.spineWinCountContainer.scale.set(scaleRow2 * 0.9);
				this.spineWinCountContainer.position.x = availableWidthRow2 / 2;
				this.spineWinCountContainer.position.y = availableHeight + counters.Height / 2;

				this.spineSpinsRemaining.scale.set(scaleRow2 * 0.9);
				this.spineSpinsRemaining.position.x = availableWidth / 4 * 3;
				this.spineSpinsRemaining.position.y = availableHeight + counters.Height / 2;
			}
			//row3
			{
				const scaleMultiplierX = availableWidth / bonusMultiplierSize.Width;
				const scaleMultiplierY = availableHeight / bonusMultiplierSize.Height;
				const scaleMultiplier = Math.min(scaleMultiplierX, scaleMultiplierY);
				this.bonusMultiplier.View().scale.set(scaleMultiplier * 4);
				this.bonusMultiplier.View().position.x = availableWidth / 4;
				this.bonusMultiplier.View().position.y = availableHeight * 2 + bonusMultiplierSize.Height / 6;
			}
		}

		this.reelsView.position.x = (this.containerBonusViewApp.fixedWidth ) / 2
		this.reelsView.position.y = this.containerBonusViewApp.fixedHeight



	}

	private SetToDefault(): void {

		this.bonusGameInfoStats.position.x = 0;
		this.bonusGameInfoStats.position.y = 0;

		this.bonusGameAwardViewPIXIAPP.scale.set(1);
		this.bonusGameAwardViewPIXIAPP.position.x = 0;
		this.bonusGameAwardViewPIXIAPP.position.y = 0;

		this.spineBonusTitle.scale.set(1);
		this.spineBonusTitle.position.x = 0;
		this.spineBonusTitle.position.y = 0;
		// this.spineBonusTitle.pivot.set(0, 0)

		this.spineWinCountContainer.scale.set(1);
		this.spineWinCountContainer.position.x = 0;
		this.spineWinCountContainer.position.y = 0;

		this.spineSpinsRemaining.scale.set(1);
		this.spineSpinsRemaining.position.x = 0;
		this.spineSpinsRemaining.position.y = 0;

		this.bonusMultiplier.View().scale.set(1);
		this.bonusMultiplier.View().position.x = 0;
		this.bonusMultiplier.View().position.y = 0;

		this.responsiveSizeStatsContainer.percentWidth = 1;
		this.responsiveSizeStatsContainer.percentHeight = 1;
		this.responsiveSizeStatsContainer.percentX = 0;
		this.responsiveSizeStatsContainer.percentY = 0;

		this.responsiveSizeContainer.percentWidth = 1;
		this.responsiveSizeContainer.percentHeight = 1;
		this.responsiveSizeContainer.percentX = 0;
		this.responsiveSizeContainer.percentY = 0;


	}

}
